export default __webpack_public_path__ + "static/media/poschL.2e2d27c1.jpg";